import PropTypes from 'prop-types'
import { Table, Tbody, Thead, Tr } from '@chakra-ui/react'
import { numberFormatter } from 'lib'
import { ThMetric, TdMetric } from './common'

export const MetricsProduction = ({ data }) => {
  return (
    <Table>
      <Thead>
        <Tr>
          <ThMetric w="7%">Department</ThMetric>
          <ThMetric w="7%">Sub Department</ThMetric>
          <ThMetric w="10%">Measure</ThMetric>
          <ThMetric w="10%">Unit of Measure</ThMetric>
          {data.dateHeaders.map(dateHeader => <ThMetric key={dateHeader.date}>{dateHeader.text}</ThMetric>)}
        </Tr>
      </Thead>
      <Tbody>
        <Tr>
          <TdMetric rowSpan={16}>Production</TdMetric>
          <TdMetric rowSpan={4}>Overall</TdMetric>
          <TdMetric rowSpan={2}>Total</TdMetric>
          <TdMetric>Count #</TdMetric>
          {data.dateHeaders.map(dateHeader => <TdMetric key={dateHeader.date}>{dateHeader.production.overall.total.count}</TdMetric>)}
        </Tr>
        <Tr>
          <TdMetric>Amount $</TdMetric>
          {data.dateHeaders.map(dateHeader => <TdMetric key={dateHeader.date}>{numberFormatter(dateHeader.production.overall.total.amount)}</TdMetric>)}
        </Tr>
        <Tr>
          <TdMetric rowSpan={2}>New Last 7 days</TdMetric>
          <TdMetric>Count #</TdMetric>
          {data.dateHeaders.map(dateHeader => <TdMetric key={dateHeader.date}>{dateHeader.production.overall.new.count}</TdMetric>)}
        </Tr>
        <Tr>
          <TdMetric>Amount $</TdMetric>
          {data.dateHeaders.map(dateHeader => <TdMetric key={dateHeader.date}>{numberFormatter(dateHeader.production.overall.new.amount)}</TdMetric>)}
        </Tr>
        <Tr>
          <TdMetric></TdMetric>
          <TdMetric>Orders submitted in last 7 days</TdMetric>
          <TdMetric>Count #</TdMetric>
          {data.dateHeaders.map(dateHeader => <TdMetric key={dateHeader.date}>{dateHeader.production.ordersSubmittedLast7Days}</TdMetric>)}
        </Tr>
        {/* Production - Ordering */}
        {/* <Tr>
          <TdMetric rowSpan={1}>Ordering</TdMetric>
          <TdMetric>{'Orders not submitted >3'}</TdMetric>
          <TdMetric>Count #</TdMetric>
          {data.dateHeaders.map(dateHeader => <TdMetric key={dateHeader.date}>{dateHeader.production.ordering.ordersNotSubmitted.count}</TdMetric>)}
        </Tr> */}
        {/* Production - Shipping */}
        <Tr>
          <TdMetric rowSpan={5}>Shipping</TdMetric>
          {/* <TdMetric rowSpan={2}>Cleared for Shipping</TdMetric>
          <TdMetric>Count #</TdMetric>
          {data.dateHeaders.map(dateHeader => <TdMetric key={dateHeader.date}>{dateHeader.production.shipping.clearedForShipping.count}</TdMetric>)} */}
        </Tr>
        {/* <Tr>
          <TdMetric>Amount $</TdMetric>
          {data.dateHeaders.map(dateHeader => <TdMetric key={dateHeader.date}>{numberFormatter(dateHeader.production.shipping.clearedForShipping.amount)}</TdMetric>)}
        </Tr> */}
        <Tr>
          <TdMetric rowSpan={2}>Shipped Last 7 Days</TdMetric>
          <TdMetric>Count #</TdMetric>
          {data.dateHeaders.map(dateHeader => <TdMetric key={dateHeader.date}>{dateHeader.production.shipping.shippedLast7Days.count}</TdMetric>)}
        </Tr>
        <Tr>
          <TdMetric>Amount $</TdMetric>
          {data.dateHeaders.map(dateHeader => <TdMetric key={dateHeader.date}>{numberFormatter(dateHeader.production.shipping.shippedLast7Days.amount)}</TdMetric>)}
        </Tr>
        {/* <Tr>
          <TdMetric>In transit</TdMetric>
          <TdMetric>Count #</TdMetric>
          {data.dateHeaders.map(dateHeader => <TdMetric key={dateHeader.date}>{dateHeader.production.shipping.inTransit.count}</TdMetric>)}
        </Tr> */}
        {/* <Tr>
          <TdMetric>Shipment Received</TdMetric>
          <TdMetric>Count #</TdMetric>
          {data.dateHeaders.map(dateHeader => <TdMetric key={dateHeader.date}>{dateHeader.production.shipping.shipmentReceived.count}</TdMetric>)}
        </Tr> */}
        <Tr>
          <TdMetric rowSpan={2}>Days from Production to out the door shipping</TdMetric>
          <TdMetric>Avg</TdMetric>
          {data.dateHeaders.map(dateHeader => <TdMetric key={dateHeader.date}>{dateHeader.production.shipping.daysProductionToOutdoorShipping.avg}</TdMetric>)}
        </Tr>
        <Tr>
          <TdMetric>Median</TdMetric>
          {data.dateHeaders.map(dateHeader => <TdMetric key={dateHeader.date}>{dateHeader.production.shipping.daysProductionToOutdoorShipping.median}</TdMetric>)}
        </Tr>
      </Tbody>
    </Table>
  )
}

MetricsProduction.propTypes = {
  data: PropTypes.object
}
